import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class DocumentSettingsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.allowedFileTypes = [];
    }
    pk() {
        return "Settings";
    }
}
DocumentSettingsResource.urlRoot = legacyApiResourceUrl("DocumentGrid");
//# sourceMappingURL=DocumentSettingsResource.js.map